<template>
  <div>
    <h1></h1>
  </div>
</template>

<script>
import axios from 'axios';
import { mapState,mapMutations } from 'vuex';


export default {
  name: 'LoginResPage',
  data() {
    return {
      user: null
    };
  },
  computed: {
        ...mapState(['redirectPath']), // 取得 store 中的 redirectPath
    },
  mounted() {
    axios.get('/api/login/getuser')
      .then(response => {
        this.handleLoginSuccess(response);
      })
      .catch(error => {
        console.error('Error fetching user data:', error);
      });
  },
  methods: {
    ...mapMutations([
      'setRedirectPath',
      'setLoggedIn',
      'setUserProfile' // 將 `setUserProfile` 映射為同名的組件方法
    ]),
    handleLoginSuccess(response) {
      if (response.data.success) {
        console.log(response.data);
        this.setLoggedIn(true);
        this.setUserProfile(response.data.user);
        if (this.redirectPath) {
            this.$router.push(this.redirectPath)
            this.setRedirectPath(null)
            return;
        }
        if (
          response.data.user.username == null ||
          response.data.user.username == '' ||
          response.data.user.birthday == null ||
          response.data.user.phone == null ||
          response.data.user.email == null) {  // 如果用户信息不完整，跳转到个人信息页面 
          this.$router.push('/profile');
        } else {
          this.$router.push('/'); // 使用路由器实例跳转到首页
        }
      }
    },
  }
};
</script>
